<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import DRBtn from "@/components/UI/DRBtn.vue";

defineProps<{
  observationsCount: number;
}>();

defineEmits<{
  (e: "generate"): void;
  (e: "dismiss"): void;
}>();

const { t } = useTranslation();
</script>

<template>
  <div class="ai-first-time-banner">
    <div class="banner-content d-flex align-items-center gap-4 px-4 py-3">
      <!-- Icon -->
      <div class="icon-container">
        <el-icon size="32">
          <i class="bi-stars"></i>
        </el-icon>
      </div>

      <!-- Text content -->
      <div class="flex-grow-1">
        <div class="fw-medium mb-1">
          {{ t("report:ai.firstTime.title") }}
        </div>
        <small class="text-muted-light">
          {{ t("report:ai.firstTime.message", { count: observationsCount }) }}
        </small>
      </div>

      <!-- Actions -->
      <div class="d-flex gap-2 align-items-center">
        <DRBtn
          variant="ia"
          :label="t('report:ai.firstTime.generateButton')"
          icon="bi-stars"
          @click="$emit('generate')"
        />
        <DRBtn
          variant="outline-white"
          :label="t('report:ai.firstTime.dismissButton')"
          @click="$emit('dismiss')"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ai-first-time-banner {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.banner-content {
  max-width: 1200px;
  margin: 0 auto;
}

.icon-container {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.text-muted-light {
  color: rgba(255, 255, 255, 0.8);
}

@media (max-width: 768px) {
  .banner-content {
    flex-direction: column;
    text-align: center;
    gap: 16px !important;
  }

  .icon-container {
    width: 48px;
    height: 48px;
  }
}
</style>
